<template>
    <van-swipe-cell :on-close="onClose">
        <div class="diagram-record-item com-record-item dsp-flex" @click.passive="clickRecordItem">
            <div class="com-record-basic diagram-record-basic">
                <div class="diagram-record-info-box">
                    <div class="com-record-name diagram-record-name">{{source.f_title}}</div>
                    <p class="com-record-info">
                        <span class="diagram-record-item-label label-one" :class="{'cur': source.hasFb}">{{source.hasFb ? '有反馈' : '无反馈'}}</span>
                        <span class="diagram-record-item-label label-two">{{source.f_type_str}}</span>
                        <span class="diagram-record-item-label">{{source.f_fb_status_str}}</span>
                    </p>
                </div>
            </div>
            <div class="diagram-record-second">
                <span class="one">{{source.f_oname_s}}</span>
            </div>
            <div class="diagram-record-second">
                <span class="two">{{source.f_cname_s}}</span>
            </div>
        </div>
        <template slot="right">
            <div class="com-record-delete">删除</div>
        </template>
    </van-swipe-cell>
</template>

<script>
export default {
    name: 'DiagramRecordItem',
    props: {
        source: {
            type: Object,
            default () { return {} }
        }
    },
    methods: {
        clickRecordItem() {
            // console.log('clickRecordItem----', this.source)
            let curPath = this.$router.history.current.path;
            let fullPath = this.$router.history.current.fullPath;
            console.log('clickRecordItem------', fullPath);
            this.$store.dispatch('diagram/startRecordDiagram', {
                diagramData: this.source,
                sucCb: () => {
                    if(curPath.indexOf('embedded') != -1) {
                        fullPath = fullPath.replace('/diagramrecord', '/diagramdetail/'+this.source.id)
                        setTimeout(() => {
                            this.$router.replace(fullPath);
                        }, 100);
                    }else {
                        this.$router.replace('/diagramdetail/'+this.source.id);
                    }
                }
            });
        },
        onClose(clickPosition, instance) {
            switch (clickPosition) {
                case 'cell':
                case 'outside':
                    instance.close();
                    break;
                case 'right':
                    this.$bus.emit('showDeleteRecordItemPop', {
                        text1: '确定要删除这一条记录吗？',
                        cb: () => {
                            this.$store.dispatch('diagram/deleteDiagram', this.source.id);
                            instance.close();
                        }
                    })
                break;
            }

        }
    }
}
</script>
